<template>
  <div class="layout" v-if="!loading">
    <aside class="px-0 bg-dark style_nav_compte">
        <nav class="navbar navbar-expand-sm navbar-dark border-0 p-0 bg-dark">
            <a class="navbar-brand d-block d-sm-none" href="#">
                <img src="../../assets/img/logo.png" height="50" class="d-inline-block align-top" alt="">
            </a>
            <button class="navbar-toggler mr-2" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse p-0 w-100 navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav w-100 list-group flex-column float-left">
                    <div class="d-none d-sm-block style_border_b py-3 px-3">
                        <router-link class="navbar-brand my-auto" :to="{name: 'home'}">
                            <img src="../../assets/img/favicon.png" height="27" class="d-inline-block align-top my-auto mr-1" alt=""><span class="my-auto">ROSS</span>
                        </router-link>
                    </div>
                    <div class="style_border_b p-3">
                        <h6 class="text-white">{{user.name}}</h6>
                        <small ><router-link class="text-secondary" :to="{name: 'profile'}"><i class="fa fa-user-circle"></i> Profile</router-link></small> | <small ><a href="" class="text-secondary" @click.prevent="logout"><i class="fa fa-power-off"></i> Déconnexion</a></small>
                    </div>
                    <li class="nav-item list-group-item bg-transparent border-0 py-1 pl-3 list-group-item-action">
                        <router-link class="nav-link" :to="{name: 'ross'}"><i class="fa fa-tachometer-alt mr-2"></i>Home <span class="ml-5 badge badge-warning"><i class="fa fa-bell mr-2"></i>{{user.devise}}</span></router-link>
                    </li>
                    <li class="nav-item list-group-item bg-transparent border-0 py-1 pl-3 list-group-item-action" v-for="(item, i) in items" :key="i">
                        <router-link class="nav-link" :to="{name: item.url}"><i :class="'mr-2 fa fa-'+item.icon"></i>{{item.name}}</router-link>
                    </li>
                </ul>
            </div>
        </nav>
    </aside>
    <div class="d-flex">
        <div class="important style_nav_compte_block d-none d-sm-block"></div>
        <div class="w-100">
            <div class="py-4 container">
                <div class="jumbotron">
                    <h1 class="display-2 gothicb">
                        <i class="fa fa-wallet"></i> 
                        <span class="style_ross_2"> {{user.solde.toString().replace('.', ',') |currency}}</span>
                    </h1><hr class="my-4">
                    <div class="row">
                        <div :class="'col-sm-'+ parseInt(12/items.length)" v-for="(item, i) in items" :key="i">
                            <router-link class="btn btn-warning btn-block btn-lg mb-2" :to="{name: item.url}" role="button"><i :class="'mr-2 fa fa-'+item.icon"></i> {{item.name}}</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <router-view/>
        </div>
    </div>
  </div><loader v-else/>
</template>

<script>
export default {
  name: 'layout',
  data() {return { loading: true }},
  computed: {
    user() {
      return this.$store.getters.loggedAs
    },
    items() {
      switch (this.user.type) {
        case 'Officiel': return this.user.owner.role === 'ADMIN' ?
        [
            {url: 'ordre', name: 'Ordres', icon: 'industry'}, //university
            {url: 'bond', name: 'Bonds', icon: 'signal'},
            {url: 'rate', name: 'Taux', icon: 'percent'},
            {url: 'wallet', name: 'Users', icon: 'users'},
        ]:[
            {url: 'tiers', name: 'Tiers', icon: 'credit-card'},
            {url: 'depot', name: 'Charger', icon: 'arrow-down'},
            {url: 'retrait', name: 'Retirer', icon: 'arrow-up'},
            {url: 'rate', name: 'Taux', icon: 'chart-bar'},
        ];
        case 'Marchand': return [
            {url: 'tiers', name: 'Tiers', icon: 'credit-card'},
            {url: 'depot', name: 'Charger', icon: 'arrow-down'},
            {url: 'transfer', name: 'Envoyer', icon: 'exchange-alt'},
            {url: 'retrait', name: 'Retirer', icon: 'arrow-up'},
            {url: 'rate', name: 'Taux', icon: 'chart-bar'},
        ];
        case 'Standard': return this.user.owner.role === 'ADMIN' ?
        [
            {url: 'souscri', name: 'Souscrire', icon: 'share-square'},
            {url: 'transfer', name: 'Envoyer', icon: 'retweet'},
            {url: 'transfer', name: 'Payer', icon: 'qrcode'},
            {url: 'service', name: 'Services', icon: 'shopping-cart'},
        ]:[
            {url: 'transfer', name: 'Envoyer', icon: 'exchange-alt'},
            {url: 'transfer', name: 'Payer', icon: 'qrcode'},
            {url: 'service', name: 'Services', icon: 'gift'},
        ];
        default: return [];
      }
    },
  },
  methods: {
    statusFromId(id) {
        const status = ({
            0: 'Asleep',
            1: 'Eating',
            2: 'Learning Vue'
        })[id];
        return status || 'Unknown status: ' + id;
    },
    filterPositive(numbers) {
      return numbers.filter(number => number >= 0);
    },
    logout() { 
        this.$store.dispatch("logout").then(() => this.$router.push({name: 'home'})); 
    },
    getColor(n = (1 - Math.random())) {
      return `hsl(${Math.floor(n  * 360)}, 100%, 75%)`;
    },
    handleKeyup(e) {
      if (e.keyCode === 27) {
        // <form @keyup.{enter.exact|esc|tab|space}="handleKeyup">...</form>
      }
    }
  },
  filters: {
    formatCost(value, symbol) {
      return symbol + (value / 100).toFixed(2);
    }
  },
  mounted() {
    this.$store.watch((state, getters) => getters.statusOn, next => {
        if(next === 'success') this.$toasted.success('Great, everything is okay.', {icon : 'check'});
        if(next === 'failure') this.$toasted.error('Ooops! something is wrong.', {icon : 'bug'});//this.loading = next !== 'pending'
    });
  },
  created() { this.$store.dispatch("profile").then(() => this.loading = false); },
}
</script>

<style lang="scss"></style>